import React from 'react';
import {
    Drawer,
    Box,
    Typography,
    IconButton,
    Switch,
    FormControlLabel,
    Divider,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ThresholdSlider } from './ThresholdSlider';
import { DashboardPreferences } from 'hooks/useDashboardPreferences';

interface DashboardSettingsPanelProps {
    open: boolean;
    onClose: () => void;
    preferences: DashboardPreferences;
    onToggleDefaultLandingPage: (value: boolean) => void;
    onThresholdsChange: (low: number, high: number) => void;
}

export const DashboardSettingsPanel: React.FC<DashboardSettingsPanelProps> = ({
    open,
    onClose,
    preferences,
    onToggleDefaultLandingPage,
    onThresholdsChange,
}) => {
    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={onClose}
            data-testid="dashboard-settings-panel"
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 2,
            }}
            PaperProps={{
                'data-testid': 'dashboard-settings-panel-container',
            }}
        >
            <Box
                data-testid="dashboard-settings-panel-content"
                sx={{ width: 600, minHeight: '100vh', p: 4, backgroundColor: 'background.paper' }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                    <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary' }}>
                        Dashboard Settings
                    </Typography>
                    <IconButton
                        data-testid="dashboard-settings-close-button"
                        onClick={onClose}
                        aria-label="Close dashboard settings"
                    >
                        <CloseIcon sx={{ color: 'text.primary' }} />
                    </IconButton>
                </Box>

                <Divider sx={{ mb: 2 }} />

                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: 'text.secondary' }}>
                    Default View Settings
                </Typography>
                <FormControlLabel
                    control={
                        <Switch
                            data-testid="dashboard-settings-default-landing-toggle"
                            checked={preferences.isDefaultLandingPage}
                            onChange={(e) => onToggleDefaultLandingPage(e.target.checked)}
                            inputProps={{ 'aria-label': 'Set Dashboard as Default Landing Page' }}
                        />
                    }
                    label="Set Dashboard as Default Landing Page"
                    sx={{ color: 'text.primary' }}
                />

                <Divider sx={{ my: 3 }} />

                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 2, color: 'text.secondary' }}>
                    Transaction Count Threshold Colors
                </Typography>
                <ThresholdSlider
                    low={preferences.thresholdLow}
                    high={preferences.thresholdHigh}
                    onChange={onThresholdsChange}
                />
            </Box>
        </Drawer>
    );
};